import Connections from '@/features/connections';
import { listWhatsappConnectionQuery } from '@/queries/whatsapp.query';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/connections/')({
  component: Connections,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(listWhatsappConnectionQuery);
  },
  head: () => ({
    meta: [{
      title: 'Conexões | Wazai',
    }]
  }),
})
